/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import { Route } from 'react-router-dom'

const PaypalReturnPage = lazy(() =>
  import('@/pages/payments/PaypalReturnPage').then((m) => ({ default: m.PaypalReturnPage })),
)
const CardnetReturnPage = lazy(() =>
  import('@/pages/payments/CardnetReturnPage').then((m) => ({ default: m.CardnetReturnPage })),
)
const AzulReturnPage = lazy(() =>
  import('@/pages/payments/AzulReturnPage').then((m) => ({ default: m.AzulReturnPage })),
)

export function paymentReturnRoutes() {
  return (
    <>
      {/* Transient PayPal popup landing pages: the popup redirects here after
          approve/cancel; the page captures the order + signals its opener,
          then self-closes. Minimal (logo-only) chrome via resolveChrome. */}
      <Route path="/payments/paypal/return" element={<PaypalReturnPage mode="return" />} />
      <Route path="/payments/paypal/cancel" element={<PaypalReturnPage mode="cancel" />} />
      {/* CardNet return landing pages (brick C4). Unlike PayPal's transient
          popup relay, these are REAL pages: the player lands here full-page
          after a redirect, the page confirms the pull-based result, and shows
          the six §4.4 states. Logo-only chrome via resolveChrome. */}
      <Route path="/payments/cardnet/return" element={<CardnetReturnPage mode="return" />} />
      <Route path="/payments/cardnet/cancel" element={<CardnetReturnPage mode="cancel" />} />
      {/* AZUL return landing pages (brick AZUL). Same real-page pattern as CardNet:
          the player lands here full-page after AZUL's hosted "Página de Pago", the
          page forwards the return querystring to confirm, and shows the six states. */}
      <Route path="/payments/azul/return" element={<AzulReturnPage mode="return" />} />
      <Route path="/payments/azul/cancel" element={<AzulReturnPage mode="cancel" />} />
    </>
  )
}
